<app-modal title="Annuler l'acompte" size="sm" closeLabel="Fermer" (closed)="close()">
  <form [formGroup]="annulationForm">
    @if (infosAcompteEnCours(); as infosAcompte) {
      <p>
        Voulez-vous annuler l'acompte de
        <strong>{{ infosAcompte.montantAcompte | devise }}</strong>
        pour la formule
        <strong>{{ infosAcompte.nom }} - {{ infosAcompte.idAparte }}</strong>
        ?
      </p>
    }

    <app-form-field label="Commentaire" [required]="true">
      <app-input multiline [rows]="3" formControlName="commentaire" />
      @if (annulationFormSuivi().controls.commentaire.hasError('required')) {
        <span appFieldError>Le commentaire est obligatoire</span>
      }
      @if (annulationFormSuivi().controls.commentaire.hasError('minlength')) {
        <span appFieldError>Le commentaire doit faire au minimum 3 caractères</span>
      }
    </app-form-field>
  </form>

  <div appModalFooter>
    <button type="button" appButton variant="ghost" (click)="close()">Non</button>
    <button
      type="button"
      appButton
      variant="primary"
      [disabled]="!annulationFormSuivi().valid || !infosAcompteEnCours()"
      (click)="submit()"
    >
      Oui
    </button>
  </div>
</app-modal>
